module.exports = __webpack_public_path__ + "img/KantoPreview.7b061515.png";